export const SET = 'Analysis/data/questions/SET';

export function setQuestions(questions) {
  return {
    type: SET,
    questions
  }
}